export interface GiscusWidgetConfig {
  containerId: string;
  mapping?: 'pathname' | 'url' | 'title' | 'og:title' | 'specific' | 'number';
  term?: string;
  category?: string;
  categoryId?: string;
  reactionsEnabled?: boolean;
  emitMetadata?: boolean;
  inputPosition?: 'top' | 'bottom';
  theme?: string;
  lang?: string;
}

export class GiscusWidget {
  private config: GiscusWidgetConfig;

  constructor(config: GiscusWidgetConfig) {
    this.config = {
      mapping: 'pathname',
      category: 'General',
      reactionsEnabled: true,
      emitMetadata: false,
      inputPosition: 'top',
      theme: 'dark_dimmed',
      lang: 'en',
      ...config
    };
  }

  public render(): string {
    return `<div id="${this.config.containerId}" class="giscus-wrapper min-h-[160px] w-full"></div>`;
  }

  public mount() {
    const container = document.getElementById(this.config.containerId);
    if (!container) return;

    // Clear prior script or iframe
    container.innerHTML = '';

    const script = document.createElement('script');
    script.src = 'https://giscus.app/client.js';
    script.setAttribute('data-repo', 'kimusan/mastui');
    script.setAttribute('data-repo-id', 'R_kgDOPb6njA'); // kimusan/mastui
    script.setAttribute('data-category', this.config.category || 'General');
    script.setAttribute('data-category-id', this.config.categoryId || 'DIC_kwDOPb6njM4Cn4fX');
    script.setAttribute('data-mapping', this.config.mapping || 'pathname');
    if (this.config.term) {
      script.setAttribute('data-term', this.config.term);
    }
    script.setAttribute('data-strict', '0');
    script.setAttribute('data-reactions-enabled', this.config.reactionsEnabled ? '1' : '0');
    script.setAttribute('data-emit-metadata', this.config.emitMetadata ? '1' : '0');
    script.setAttribute('data-input-position', this.config.inputPosition || 'top');
    script.setAttribute('data-theme', 'dark_dimmed');
    script.setAttribute('data-lang', this.config.lang || 'en');
    script.setAttribute('crossorigin', 'anonymous');
    script.async = true;

    container.appendChild(script);
  }

  public destroy() {
    const container = document.getElementById(this.config.containerId);
    if (container) {
      container.innerHTML = '';
    }
  }
}
